const headers = [
  // {
  //   label: "เลขร้องทุกข์",
  //   field: "Code",
  // },
  {
    label: "เลขเอกสาร",
    field: "docCode",
  },
  {
    label: "ประเภทเอกสาร",
    field: "file",
  },
  {
    label: "สถานะ / ผู้อนุมัติ",
    field: "status",
  },
  // {
  //   label: "วันที่ดำเนินการ",
  //   field: "Complain_Date",
  // },
  {
    label: "ผู้สร้างเอกสาร",
    field: "name",
  },
  {
    label: "สถานะการตรวจสอบจากเลขา",
    field: "statusSecretaryVerification",
  },
  {
    label: "Action",
    field: "action",
  },
];

export default headers;
